import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function externalTicketReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_EXTERNAL_TICKET:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_EXTERNAL_TICKET_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_EXTERNAL_TICKETS:
    case actions.SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_EXTERNAL_TICKETS_ENDED:
    case actions.SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_EXTERNAL_TICKET:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_EXTERNAL_TICKET_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
}
